/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { trackAlbumBindModelSchema } from "./trackAlbumBindModelSchema.ts";
import { trackAuthorBindModelSchema } from "./trackAuthorBindModelSchema.ts";
import { trackTagBindModelSchema } from "./trackTagBindModelSchema.ts";
import { trackTypeEnumSchema } from "./trackTypeEnumSchema.ts";
import { trackUploadStatusSchema } from "./trackUploadStatusSchema.ts";
import { z } from "zod";

export const trackModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор трека"),
"name": z.string().describe("Наименование трека"),
"description": z.string().describe("Описание").nullable().nullish(),
"type": z.lazy(() => trackTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Sermon</b>: Проповедь</li>\n<li><b>4 - Book</b>: Аудиокнига</li>\n<li><b>5 - Jingle</b>: Джингл</li>\n</ul>\n"),
"album": z.lazy(() => trackAlbumBindModelSchema).describe("Альбом").nullable().nullish(),
"authors": z.array(z.lazy(() => trackAuthorBindModelSchema)).describe("Список авторов"),
"genres": z.array(z.lazy(() => trackTagBindModelSchema)).describe("Список жанров").nullable().nullish(),
"moods": z.array(z.lazy(() => trackTagBindModelSchema)).describe("Теги настроения").nullable().nullish(),
"picture": z.lazy(() => fileModelSchema).describe("Обложка").nullable().nullish(),
"uploadStatus": z.lazy(() => trackUploadStatusSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Uploaded</b>: Загружен</li>\n<li><b>1 - Uploading</b>: В процессе загрузки</li>\n<li><b>2 - DeletionPending</b>: В процессе удаления</li>\n</ul>\n"),
"files": z.array(z.lazy(() => fileModelSchema)).describe("Файлы"),
"duration": z.number().int().describe("Длительность"),
"releaseDate": z.string().date().describe("Дата выпуска").nullable().nullish(),
"rowNumber": z.number().int().describe("Порядок трека в альбоме.").nullable().nullish(),
"useAlbumPicture": z.boolean().describe("Использовать обложку альбома (для картинок треков)"),
"isArchive": z.boolean().describe("В архиве")
    })